import store from '@/store';

const Monthplans = () => import(/* webpackChunkName: "plan-module" */ '@views/plan/month/Monthplans');
const Plan = () => import(/* webpackChunkName: "plan-module" */ '@views/plan/components/Plan');
const Overview = () => import(/* webpackChunkName: "plan-module" */ '@views/plan/components/Overview');
const Settings = () => import(/* webpackChunkName: "plan-module" */ '@views/plan/components/Settings');
const Templates = () => import(/* webpackChunkName: "plan-module" */ '@views/plan/components/Templates');

import {requireModule} from '@/routes/guards';

export default [
    {
        path: '/plans/month',
        components: { base: Monthplans },
        beforeEnter: requireModule('mplan'),
        children: [
            {
                path: '',
                name: 'plans.mplan',
                components: { monthplan: Plan },
                beforeEnter: (to, from, next) => {
                    if (store.getters.canAccessMonthPlan) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                }
            },
            {
                path: 'overview',
                name: 'plans.mplan.overview',
                components: { monthplan: Overview },
                beforeEnter: (to, from, next) => {
                    if (store.getters.canAccessOverView) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                }
            },
            {
                path: 'settings',
                name: 'plans.mplan.settings',
                components: { monthplan: Settings },
                beforeEnter: (to, from, next) => {
                    if (store.getters.canAccessPlansSettings) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                }
            },
            {
                path: 'templates',
                name: 'plans.mplan.templates',
                components: { monthplan: Templates },
                beforeEnter: (to, from, next) => {
                    if (store.getters.canAccessTemplates) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                }
            }
        ]
    }
];
